import { Container, Link, LinkList, Navbar, Text } from '@postenbring/hedwig-react';
import { UserIcon, ArrowUpRightIcon } from '../../shared/icons';

export const Login = ({ headerData, showLoginModal, setShowLoginModal }) => (
    <>
        <Navbar.ButtonItem aria-controls='login-modal'
            className='kp-header-login-button kp-hidden-before-large'
            onClick={() => {
                setShowLoginModal(!showLoginModal)
            }}>
            {headerData.loginLabel}
            <UserIcon />
        </Navbar.ButtonItem>
        <Container
            id='login-modal'
            as='aside'
            className="kp-hidden-before-large kp-header-dropdown-menu"
            data-state={showLoginModal ? 'open' : 'closed'}
        >
            <Text variant='h3-title'>{headerData.loginWhere}</Text>
            <LinkList>
                {headerData.loginLinks.map(({ url, title}) => (
                    <li key={url}>
                        <Link href={url} icon='leading' target='_blank'>
                            <ArrowUpRightIcon />
                            {title}
                        </Link>
                    </li>
                ))}
            </LinkList>
        </Container>
    </>
)
